<template>
  <div
    class="metric-cards grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3"
    v-loading="loading"
  >
    <div
      v-for="(item, index) in items"
      :key="index"
      class="metric-card rounded-lg border px-3 py-3"
      :class="item.highlight ? 'border-blue-200 bg-blue-50' : 'border-gray-100 bg-gray-50'"
    >
      <div class="text-xs text-gray-500 mb-1 truncate">{{ item.label }}</div>
      <div class="flex items-baseline">
        <span
          class="text-lg font-semibold"
          :class="item.highlight ? 'text-blue-600' : 'text-gray-800'"
        >
          {{ item.value }}
        </span>
        <span v-if="item.unit" class="ml-1 text-xs text-gray-500">{{ item.unit }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MetricCards',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.metric-cards {
  margin-bottom: 1rem;
}

.metric-cards .metric-card {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.metric-cards .metric-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
}
</style>
